import { apiClient } from '@/shared/api';
import { handleRequest } from '@/shared/api/apiWrapper';
import type {
  SumSubCredentialsDto,
  VerificationEulaResponseDto,
  UserVerificationInfoResponseDto,
  SubmitVerificationEulaRequestDto,
  SubmitVerificationEulaResponseDto,
  VerificationProfileResponseDto,
  SubmitVerificationProfileRequestDto,
  SubmitVerificationProfileResponseDto,
  VerificationQuestionariesResponseDto,
  SubmitVerificationQuestionariesRequestDto,
  SubmitVerificationQuestionariesResponseDto,
} from './types';

export const getUserVerificationInfo = async () => {
  const request = () => apiClient.get('/users/verification/info');
  const response =
    await handleRequest<UserVerificationInfoResponseDto>(request);
  return response.data;
};

export const getVerificationEula = async () => {
  const request = () => apiClient.get('/users/verification/eula');
  const response = await handleRequest<VerificationEulaResponseDto>(request);
  return response.data;
};

export const postVerificationEula = async (
  args: SubmitVerificationEulaRequestDto
) => {
  const request = () => apiClient.post('/users/verification/eula', args);
  const response =
    await handleRequest<SubmitVerificationEulaResponseDto>(request);
  return response.data;
};

export const getVerificationProfile = async () => {
  const request = () => apiClient.get('/users/verification/profile');
  const response = await handleRequest<VerificationProfileResponseDto>(request);
  return response.data;
};

export const postVerificationProfile = async (
  args: SubmitVerificationProfileRequestDto
) => {
  const request = () => apiClient.post('/users/verification/profile', args);
  const response =
    await handleRequest<SubmitVerificationProfileResponseDto>(request);
  return response.data;
};

export const getVerificationQuestionaries = async () => {
  const request = () => apiClient.get('/users/verification/questionaries');
  const response =
    await handleRequest<VerificationQuestionariesResponseDto>(request);
  return response.data;
};

export const postVerificationQuestionaries = async (
  args: SubmitVerificationQuestionariesRequestDto
) => {
  const request = () =>
    apiClient.post('/users/verification/questionaries', args);
  const response =
    await handleRequest<SubmitVerificationQuestionariesResponseDto>(request);
  return response.data;
};

export const getSumSubCredentials = async () => {
  const request = () => apiClient.get('/users/verification/sumsub');
  const response = await handleRequest<SumSubCredentialsDto>(request);
  return response.data;
};
